<template>
	<div class="w-100 h-100">
		<error></error>
		<div v-if="!isRegistered" class="h-100">
			<form onsubmit="return false;" ref="form" class="scroll-wrapper">
				<v-row><v-col>
				<c-input
					v-model="firstName"
					labelWidth="10%"
					:title="$t('text.firstName')"
					:disabled="loading"
					:error="errors.firstName"
					@validate="validateFirstName">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="lastName"
					labelWidth="10%"
					:title="$t('text.lastName')"
					:disabled="loading"
					:error="errors.lastName"
					@validate="validateLastName">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="email"
					labelWidth="10%"
					:title="$t('text.email')"
					:disabled="loading"
					:error="errors.email"
					@validate="validateEmail">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="password"
					labelWidth="10%"
					type="password"
					:title="$t('text.password')"
					:disabled="loading"
					:error="errors.password"
					@validate="validatePassword">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="confirmPassword"
					labelWidth="10%"
					type="password"
					:title="$t('text.confirmPassword')"
					:disabled="loading"
					:error="errors.confirmPassword"
					@validate="validateConfirmPassword">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="organization.selected"
					:options="masterOrganizations"
					:disabled="hasOnlyOneOrganization || loading"
					labelWidth="10%"
					type="select"
					:title="$t('text.masterorganization')"
					:error="errors.organization"
					@validate="validateOrganization">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="language.selected"
					:options="allLanguages"
					:disabled="hasOnlyOneLanguage || loading"
					labelWidth="10%"
					type="select"
					:title="$t('text.language')"
					:error="errors.language"
					@validate="validateLanguage">
				</c-input>
				</v-col></v-row>
			</form>
			<c-button
				:disabled="loading || !validateForm()"
				@click="register"
				type="important"
				:label="$t(`text.registerButton`)">
			</c-button>
		</div>
		<v-alert v-else type="success">
			{{ $t(`text.registrationSuccess`) }}
		</v-alert>
		<spinner :loading="loading"></spinner>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import authActions from '../store/actions/auth';
import organizationActions from '../store/actions/organization';
import languageActions from '../store/actions/language';
import namespace from '../store/namespace';

import CInput from '../globalComponents/CInput.vue';
import CButton from '../globalComponents/CButton.vue';
import Error from '../general/Error.vue';

import Spinner from '../general/Spinner.vue';

import modelState from '../mixins/modelState';
import rules from '../globalComponents/mixins/rules';

export default {
	name: 'Register',
	mixins: [modelState, rules],
	components: {
		CInput,
		CButton,
		Spinner,
		Error,
	},
	async mounted() {
		await this.getMasterOrganizations();
		await this.getLanguages();
		this.$refs.form.style.height = `${this.WindowSize.y - 170}px`;
	},
	data() {
		return {
			firstName: '',
			lastName: '',
			email: '',
			errors: {
				firstName: {},
				lastName: {},
				email: {},
				password: {},
				confirmPassword: {},
				organization: {},
				language: {},
			},
			password: '',
			confirmPassword: '',
			language: {
				items: [],
				selected: '1',
			},
			organization: {
				items: [],
				selected: '',
			},
			modelState: {},
			confirmed: false,
			loading: false,
		};
	},
	computed: {
		...mapGetters(['WindowSize']),
		isRegistered() {
			return this.confirmed;
		},
		masterOrganizations() {
			return this.organization.items;
		},
		allLanguages() {
			return this.language.items;
		},
		hasOnlyOneOrganization() {
			return this.organization.items.length === 1;
		},
		hasOnlyOneLanguage() {
			return this.organization.items.length === 1;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.REGISTER]),
		...mapActions(namespace.ORGANIZATION, [organizationActions.GET_MASTER_ORGANIZATIONS]),
		...mapActions(namespace.LANGUAGE, [languageActions.GET_LANGUAGES]),
		apiErrors(propName) {
			const apiErrors = this.validateProperty(propName);

			if (apiErrors.length > 0) return { show: true, message: apiErrors };

			return {};
		},
		validateForm() {
			const val = Object.keys(this.errors);

			const ret = val.every((p) => {
				if (this.errors[p].show === true) {
					return false;
				}
				return true;
			});

			return ret;
		},
		validateFirstName() {
			this.errors.firstName = {};
			if (this.isEmpty(this.firstName)) this.errors.firstName = { show: true, message: this.$i18n.t('text.errorFirstNameRequired') };
			else this.errors.firstName = this.apiErrors('FirstName');
		},
		validateLastName() {
			this.errors.lastName = {};
			if (this.isEmpty(this.lastName)) this.errors.lastName = { show: true, message: this.$i18n.t('text.errorLastNameRequired') };
			else this.errors.lastName = this.apiErrors('LastName');
		},
		validateEmail() {
			this.errors.email = {};
			if (this.isEmpty(this.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorEmailRequired') };
			else if (this.isInvalidEmail(this.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorInvalidEmail') };
			else this.errors.email = this.apiErrors('Email');
		},
		validatePassword() {
			this.errors.password = {};
			if (this.isEmpty(this.password)) this.errors.password = { show: true, message: this.$i18n.t('text.errorPasswordRequired') };
			else this.errors.password = this.apiErrors('Password');
			this.validateConfirmPassword();
		},
		validateConfirmPassword() {
			this.errors.confirmPassword = {};
			if (this.isEmpty(this.confirmPassword)) this.errors.confirmPassword = { show: true, message: this.$i18n.t('text.errorConfirmPasswordRequired') };
			if (!this.isSame(this.confirmPassword, this.password)) this.errors.confirmPassword = { show: true, message: this.$i18n.t('text.errorConfirmPasswordWrong') };
			else this.errors.confirmPassword = this.apiErrors('ConfirmPassword');
		},
		validateOrganization() {
			this.errors.organization = {};
			if (this.isEmpty(this.organization.selected)) this.errors.organization = { show: true, message: this.$i18n.t('text.errorOrganizationRequired') };
			else this.errors.organization = this.apiErrors('OrganizationId');
		},
		validateLanguage() {
			this.errors.language = {};
			if (this.isEmpty(this.language.selected)) this.errors.language = { show: true, message: this.$i18n.t('text.errorLanguageRequired') };
			else this.errors.language = this.apiErrors('LanguageId');
		},
		async register() {
			this.loading = true;

			if (this.validateForm()) {
				const newUser = {
					firstName: this.firstName,
					lastName: this.lastName,
					email: this.email,
					password: this.password,
					confirmPassword: this.confirmPassword,
					languageId: this.language.selected,
					organizationId: this.organization.selected,
					confirmUrl: `${window.location.origin}/confirm`,
				};

				try {
					this.modelState = {};
					await this.REGISTER(newUser);

					this.confirmed = true;
				} catch (e) {
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new TypeError(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		async getMasterOrganizations() {
			this.organization.items = await this.GET_MASTER_ORGANIZATIONS();

			if (this.organization.items.length > 0) {
				this.organization.selected = this.organization.items[0].value;
			}
		},
		async getLanguages() {
			this.language.items = await this.GET_LANGUAGES();

			if (this.language.items.length > 0) {
				this.language.selected = this.language.items[0].value;
			}
		},
	},
	watch: {
		'WindowSize.y': function () {
			this.$refs.form.style.height = `${this.WindowSize.y - 170}px`;
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.scroll-wrapper {
	overflow: hidden auto;
}

form {
	margin-bottom: 10px;
}

</style>
